import type { ApiFileUploadTypes } from 'api/types/ApiFileUploadTypes';
import { FilePicker } from 'components/FilePicker/FilePicker';
import { Field } from 'components/Form/Field/Field';

type Props = {
  analyticsLabel?: string;
  downloadAttachment?: boolean;
  fileType?: ApiFileUploadTypes;
  name: string;
  label?: string;
  description?: string;
  'data-qa-id'?: string;
  listingType?: string;
  disabled?: boolean;
  type: 'FILE';
};

export function RequestedAttachmentUserField({
  analyticsLabel,
  downloadAttachment,
  fileType = 'LISTING_APPLICATION',
  name,
  label,
  'data-qa-id': qaId,
  type,
  listingType,
  disabled,
  description,
}: Props) {
  if (type !== 'FILE') return null;
  const subName = `${name}.s3FileId`;

  return (
    <Field
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <FilePicker
          disabled={disabled}
          downloadAttachment={downloadAttachment}
          fileId={value?.s3FileId}
          fileType={fileType}
          data-qa-id={qaId ?? autoQaId}
          onChange={(e) => {
            updateValue(e ? { type: 'FILE', s3FileId: e } : null);
          }}
          name={name}
          accept="application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, image/jpeg, image/png, text/plain"
          extraAnalyticsData={{
            context: 'Listing Application Form',
            listing_type: listingType,
            file_label: analyticsLabel ?? label,
          }}
          maxSize={10}
        />
      )}
    />
  );
}
